import { render } from "./UserCreationInvite.vue?vue&type=template&id=4106bf55"
import script from "./UserCreationInvite.vue?vue&type=script&lang=js"
export * from "./UserCreationInvite.vue?vue&type=script&lang=js"

import "./UserCreationInvite.vue?vue&type=style&index=0&id=4106bf55&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__